import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { InsuranceProvider } from './contexts/InsuranceContext'

// Layout
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/ProtectedRoute'

// Auth Pages
import Login from './pages/auth/Login'

// Patient Pages
import PatientSearch from './pages/patients/PatientSearch'
import PatientList from './pages/patients/PatientList'
import PatientView from './pages/patients/PatientView'
import PatientEdit from './pages/patients/PatientEdit'
import AuditLog from './pages/patients/AuditLog'

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard'
import UserManagement from './pages/admin/UserManagement'
import CMODashboard from './pages/cmo/CMODashboard'

function App() {
  return (
    <Router>
      <AuthProvider>
        <InsuranceProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes with Layout */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/patients/list" replace />} />
              
              {/* Patient Routes */}
              <Route path="patients">
                <Route path="search" element={<PatientSearch />} />
                <Route path="list" element={<PatientList />} />
                <Route path=":id/view" element={<PatientView />} />
                <Route path=":id/edit" element={<PatientEdit />} />
                <Route path=":id/audit" element={<AuditLog />} />
              </Route>
              
              {/* Admin Routes */}
              <Route path="admin">
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<UserManagement />} />
              </Route>

              {/* CMO Routes */}
              <Route path="cmo" element={<CMODashboard />} />
            </Route>
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/patients/list" replace />} />
          </Routes>
        </InsuranceProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
